import axiosInstance from '../config/axios';
import { API_ENDPOINTS } from '../config/api';

const base = API_ENDPOINTS.studyRegistration;

export async function getStudyRegistrationByProject(projectId) {
  const res = await axiosInstance.get(base, { params: { projectId } });
  return res.data;
}

export async function upsertStudyRegistration(payload) {
  const res = await axiosInstance.post(base, payload);
  return res.data;
}
